import * as React from "react";

export default function Footer() {
  return (
    <main className="items-center flex flex-col pb-8 mt-52">
      <h1 className="self-stretch text-zinc-950 text-center text-2xl font-bold leading-8 max-md:max-w-full">
        We are just starting our journey, but we promise that it will be cool!
      </h1>
      <section className="items-start opacity-50 self-center flex w-72 max-w-full gap-5 mt-7 px-5 max-md:justify-center">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/266274e4-cc30-44ec-b455-d92e331d6d3d?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 1"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/8edb3e67-0b91-44f9-8582-ccac13aadc65?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 2"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/07671c16-68d7-434f-9284-605f1c371416?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 3"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/bace22e8-32eb-446d-abb7-75ecbab78875?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 4"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b2be844-6c92-49d7-b20a-ad7c2af014ae?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 5"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/ebb00586-f7a3-4637-b1a4-8a6f12cf8fbf?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 6"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/fba190d0-fbd6-422e-b78e-5025c83b9b14?apiKey=61fd86f4dc6f4d7ea0f219865b8da95a&"
          className="aspect-square object-contain object-center w-full overflow-hidden flex-1"
          alt="Image 7"
        />
      </section>
      <footer className="self-stretch text-zinc-950 text-center text-xl leading-6 opacity-50 mt-7 max-md:max-w-full">
        © All Rights Reserved. AINA 2023
      </footer>
    </main>
  );
}
